import { render, staticRenderFns } from "./FoldersList.vue?vue&type=template&id=68cf251c&scoped=true&"
import script from "./FoldersList.vue?vue&type=script&lang=js&"
export * from "./FoldersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cf251c",
  null
  
)

export default component.exports